import type { FaireProductEntity } from "../../entity_types/product";

export const p_hc4j293vhr: FaireProductEntity = {
  token: "p_hc4j293vhr",
  type: "product",
  name: "Crystal Cat Buddha - Black or White Cat -",
  brandToken: "b_de8f5way8k",
  brandName: "Rock Paradise",
  imageUrl:
    "https://cdn.faire.com/fastly/5b3ec31ee7274c71899ad1f9652d121f64bc6a5249cfdebfa82a1a1b36a50e75.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2be4e2f05e80a2a4e109a8d205c4204d57d9c3f5090e819e1f85be1b48ea2e37.jpeg",
    "https://cdn.faire.com/fastly/7454a17437758b22b65996f1e49474c01e02488ca79e8c1f1a4e39aeb49fa1a0.jpeg",
    "https://cdn.faire.com/fastly/0c24dc6063fb0fd3d0161c260931d65f4c55e9bdc9f2b6448087753f784a8764.jpeg",
    "https://cdn.faire.com/fastly/e936ed361d2ce86716125115d5923a80b405e69204db4fc9d72ddb7c4a6e995c.jpeg",
    "https://cdn.faire.com/fastly/82d55dbc773a23d1bbb55107a303b99aeefe53cd5b0d99d6832add27717f7217.jpeg",
    "https://cdn.faire.com/fastly/c416fbaa5fa2aa7ce39b7dbb75af630f5205693e3153ad348429234d2f2eab0b.jpeg",
    "https://cdn.faire.com/fastly/f29dfe1798367e40b62d40c2fcc264a02e957457aa9ac01046a568bb586038cc.jpeg",
    "https://cdn.faire.com/fastly/39f2f1b8daef0c02ea2f8ea7063312bb673888be4d602c363f4d73eac11ca8c8.jpeg",
    "https://cdn.faire.com/fastly/e021adafd2b219f4e415f1156e75f7afbd3bffd7feb58f2cfc3a53bf99d00004.jpeg",
    "https://cdn.faire.com/fastly/49543a24e2806fb47970eb15da7546b21257b93664886b2251b94c6fd06eff94.jpeg",
  ],
  priceDollars: 19.4,
  description:
    'Crystal\nListing is for ONE (1) Cat Buddha - Black or White Cat - (RK15)\n\nSuper cute Cat Buddhas! These come in black with an antique gold accent or antique white with copper color accents. The bottom has soft black felt that prevents any surface scratching. They are so eye catching, perfect for your home decor or as a gift for that spiritual cat lover you know! Make one yours while you can!\n\nSTOCK PHOTOS These Cat Buddha statues are made of Aluminum and can vary slightly in size, color and characteristics. \n\nYou Select your favorite one! Available in:\n\n * Black \n * White \nMeasures Approx.:  3.125" x 5.75" and 1.75" thick',
  tags: [],
  msrpDollars: 44.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:21.937Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
